import { IconList } from 'components/Icon';
import {
    TEXT_MASTER_MANAGEMENT,
    TEXT_SENSOR_LIST,
    TEXT_SENSOR_MANAGEMENT,
    TEXT_SENSOR_MAP,
    TEXT_USER_MANAGEMENT
} from 'constants/message';

const PAGE_MAP = 1;
const PAGE_FLOOD_SENSOR_LIST = 2;
const PAGE_FLOOD_GATE_SENSOR_LIST = 3;
const PAGE_SENSOR_MANAGEMENT = 4;
const PAGE_USER_MANAGEMENT = 5;
const PAGE_MASTER_MANAGEMENT = 6;
const PAGE_PROFILE = 7;
const PAGE_CAMERA_SENSOR_LIST = 8;
const PAGE_GENERAL_SENSOR_LIST = 12;
const PAGE_VIEW_SENSOR = 9;
const PAGE_MODIFY_SENSOR = 10;
const PAGE_CREATE_SENSOR = 11;

const TEXT_SEND_MAIL = 'メール送信';
const TEXT_VIEW_MAP = 'マップ確認';

const SENSOR_PROPERTIES = {
    ID: 'id',
    MANAGE_ID: 'managementId',
    NAME: 'name',
    TYPE: 'type',
    GROUP_ID: 'groupId',
    API_GROUP_ID: 'apiGroupId',
    LOCATION: 'location',
    LAT: 'lat',
    LONG: 'lng',
    CREATEDAT: 'createdAt',
    TX: 'tx',
    STATUS: 'status',
    MESSAGE: 'message',
    DESCRIPTION: 'description',
    // extra properties within data object

    // FLOOD GATE SENSOR
    FLOOD_GATE_OPENING_LEVEL: 'data.gateOpeningLevel',
    INNER_WATER_LEVEL: 'data.innerWaterLevel',
    OUTER_WATER_LEVEL: 'data.outerWaterLevel',
    POWER_VOLTAGE: 'data.powerVoltage',
    FLOOD_GATE_OPENING_UNIT: 'data.gateOpeningUnit',
    FLOOD_GATE_OPENING_LEVEL_DISPLAY: 'data.openingLevelDisplay',
    ALL_STATUSES: 'data.allStatuses',
    STATUS_COUNT: 'data.statusCount',

    A: 'data.A',
    B: 'data.B',
    C: 'data.C',
    D: 'data.D',
    E: 'data.E',
    F: 'data.F',
    V0: 'data.V0',
    G0: 'data.G0',

    Wa: 'data.Wa',
    Wb: 'data.Wb',
    Wc: 'data.Wc',
    Wd: 'data.Wd',

    Wta: 'data.Wta',
    Wtb: 'data.Wtb',
    Wtc: 'data.Wtc',
    Wtd: 'data.Wtd',

    Va0: 'data.Va0',
    Va1: 'data.Va1',
    Vb0: 'data.Vb0',
    Vb1: 'data.Vb1',
    Vc0: 'data.Vc0',
    Vtc0: 'data.Vtc0',
    Vc1: 'data.Vc1',
    Vtc1: 'data.Vtc1',
    Vd1: 'data.Vd1',
    Vd2: 'data.Vd2',
    Ve: 'data.Ve',
    MAX_WATER_LEVEL: 'data.maxWaterLevel',
    MIN_WATER_LEVEL: 'data.minWaterLevel',
    MAX_OPENING_LEVEL: 'data.maxOpeningLevel',
    MIN_OPENING_LEVEL: 'data.minOpeningLevel',

    // CAMERA SENSOR
    TYPE_CAMERA: 'data.typeCamera',
    SWAP_IMAGE_CAMERA: 'data.swapImageCamera',
    TYPE_DISPLAY_CAMERA: 'data.typeDisplayCamera',
    CAMERA_FEATURE: 'data.cameraFeature',
    IP_ADDRESS: 'data.ipAddress',
    USERNAME: 'data.username',
    PASSWORD: 'data.password',

    ZOOM_IMAGE_FEATURE: 'data.zoomImageFeature',
    ZOOM_IMAGE_RATE: 'data.zoomImageRate',
    ZOOM_CENTER_COORDINATE_X: 'data.zoomCenterCoordinateX',
    ZOOM_CENTER_COORDINATE_Y: 'data.zoomCenterCoordinateY',

    SD_CARD_RECORDING: 'data.sdCardRecording',

    TRAFFIC_VOLUME_FEATURE: 'data.trafficVolumeFeature',
    TRAFFIC_VOLUME_SCENARIO: 'data.trafficVolumeScenario',
    TRAFFIC_VOLUME_NAME: 'data.trafficVolumeName',
    TRAFFIC_VOLUME_TYPE: 'data.trafficVolumeType',
    TRAFFIC_VOLUME_STORAGE_PERIOD: 'data.trafficVolumeStoragePeriod',

    IMAGE_ANALYSIS_FEATURE: 'data.imageAnalysisFeature',
    IMAGE_ANALYSIS_EXECUTION_START_TIME: 'data.imageAnalysisExecutionStartTime',
    IMAGE_ANALYSIS_EXECUTION_END_TIME: 'data.imageAnalysisExecutionEndTime',
    IMAGE_ANALYSIS_WEATHER_ACQUISTION_INTERVAL: 'data.imageAnalysisWeatherAcquistionInterval',
    IMAGE_ANALYSIS_INTERVAL: 'data.imageAnalysisInterval',
    IMAGE_ANALYSIS_SYSTEM_PROMPT: 'data.imageAnalysisSystemPrompt',
    IMAGE_ANALYSIS_USER_PROMPT: 'data.imageAnalysisUserPrompt',
    IMAGE_ANALYSIS_ZOOM_FEATURE: 'data.imageAnalysisZoomFeature',
    IMAGE_ANALYSIS_ZOOM_START_TIME: 'data.imageAnalysisZoomStartTime',
    IMAGE_ANALYSIS_ZOOM_END_TIME: 'data.imageAnalysisZoomEndTime',
    IMAGE_ANALYSIS_ZOOM_RATE: 'data.imageAnalysisZoomRate',
    IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_X: 'data.imageAnalysisZoomCenterCoordinateX',
    IMAGE_ANALYSIS_ZOOM_CENTER_COORDINATE_Y: 'data.imageAnalysisZoomCenterCoordinateY',

    STORAGE_IMAGE_INTERVAL: 'data.storageImageInterval',
    STORAGE_IMAGE_PERIOD: 'data.storageImagePeriod',

    // GENERAL SENSOR
    SOCKET_IP_ADDRESS: 'data.socketIpAddress',
    CONNECT_METHOD: 'data.connectMethod',
    NAME_SIGNAL: 'data.nameSignal',
    CONVERSION_FACTOR_SIGNAL: 'data.conversionFactorSignal',
    CORRECTION_COEFFICIENT_SIGNAL: 'data.correctionCoefficientSignal',
    UNIT_SIGNAL: 'data.unitSignal',
    DECIMAL_PART_LENGTH: 'data.decimalPartLength',
    ALARM_VALUE_SIGNAL: 'data.alarmValueSignal',
    ALARM_VALUE_OPARETOR_SIGNAL: 'data.alarmValueOparetorSignal',
    ABNORMAL_VALUE_SIGNAL: 'data.abnormalValueSignal',
    ABNORMAL_VALUE_OPARETOR_SIGNAL: 'data.abnormalValueOparetorSignal',
    NUMERICAL_UPPER_LIMIT_SIGNAL: 'data.numericalUpperLimitSignal',
    NUMERICAL_LOWER_LIMIT_SIGNAL: 'data.numericalLowerLimitSignal',
    GRAPH_AXIS_SIGNAL: 'data.graphAxisSignal',

    LEFT_Y: 'data.leftY',
    NAME_LEFT_Y: 'data.nameLeftY',
    UPPER_LIMIT_LEFT_Y: 'data.maxLeftY',
    LOWER_LIMIT_LEFT_Y: 'data.minLeftY',
    RIGHT_Y: 'data.rightY',
    NAME_RIGHT_Y: 'data.nameRightY',
    UPPER_LIMIT_RIGHT_Y: 'data.maxRightY',
    LOWER_LIMIT_RIGHT_Y: 'data.minRightY',


    NAME_CONTACT: 'data.nameContact',
    VALUE_CONTACT: 'data.valueContact',

    NAME_ALARM: 'data.nameAlarm',
    LOGIC_ALARM: 'data.logicAlarm',

    HISTORY_PERIOD: 'data.historyPeriod'
}

const UNDEFINED_TEXT = '-';

const SENSOR_MANAGE_MENU = [
    {
        page: PAGE_MAP,
        label: TEXT_SENSOR_MAP,
        icon: IconList.iconMenuMap,
    },
    {
        page: PAGE_FLOOD_SENSOR_LIST,
        label: TEXT_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
    },
    {
        page: PAGE_FLOOD_GATE_SENSOR_LIST,
        label: TEXT_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
    }
]

const MANAGER_SETTING_MENU = [
    {
        page: PAGE_SENSOR_MANAGEMENT,
        label: TEXT_SENSOR_MANAGEMENT,
        icon: IconList.iconMenuSensorManage,
    },
    {
        page: PAGE_USER_MANAGEMENT,
        label: TEXT_USER_MANAGEMENT,
        icon: IconList.iconMenuUser,
    }
]

const ADMIN_SETTING_MENU = [
    {
        page: PAGE_SENSOR_MANAGEMENT,
        label: TEXT_SENSOR_MANAGEMENT,
        icon: IconList.iconMenuSensorManage,
    },
    {
        page: PAGE_USER_MANAGEMENT,
        label: TEXT_USER_MANAGEMENT,
        icon: IconList.iconMenuUser,
    },
    {
        page: PAGE_MASTER_MANAGEMENT,
        label: TEXT_MASTER_MANAGEMENT,
        icon: IconList.iconMenuMaster,
    }
]

const ROLE = {
    GENERAL: 'general',
    LIST: 'list',
    DETAIL: 'detail',
    MANAGE: 'manage',
}

const FLOOD_GATE_MESSAGES = {
    // ABNORMAL
    0: '川表水位センサ異常',
    1: '川裏水位センサ異常',
    2: 'ゲート開度センサ異常（接点ON）',
    3: 'ゲート開度センサ異常（接点OFF）',
    4: 'ゲート異常動作',
    5: '接点・ゲート開度センサ異常',
    6: '電源電圧異常',
    7: '異常検知時間超過',
    // ALERT
    8: '川表水位警報',
    9: '川裏水位警報',
    10: '水門開度警報',
    11: '川表水位＞川裏水位警報',
    // CLOSE
    12: '全閉検知',
    13: '',
    // OPEN
    14: ''
}

const PAGE_LINK = {
    1: '/',
    2: '/list-flood-sensor',
    3: '/list-flood-gate-sensor',
    4: '/device-management',
    5: '/user-management',
    6: '/master-management',
    7: '/profile',
    8: '/list-camera-sensor',
    12: '/list-general-sensor',
    9: '/view-sensor',
    10: '/modify-sensor',
    11: '/create-sensor',
    'FLOOD': '/list-flood-sensor',
    'FLOOD_GATE': '/list-flood-gate-sensor',
    'CAMERA': '/list-camera-sensor',
    'GENERAL': '/list-general-sensor'
}

const IMAGE_ANALYSIS_USER_PROMPT_DEFAULT = `画像に写っているものを書き出し、その後考えて答えてください。道路が冠水している場合は「ABNORMAL」と答えてください。道路が冠水していない場合は「NORMAL」と答えてください。`
const IMAGE_ANALYSIS_SYSTEM_PROMPT_DEFAULT = `
    画像に写っているものをすべて書き出してください。
    書き出した内容を < image_caption ></ > として記録してください。
    画像の内容と < image_caption > に基づいて、道路が冠水しているかどうかを簡潔に教えてください。
    質問に答える前に、<thinking></thinking>タグ内でステップバイステップで考えてください。
    最後に、<answer></answer>タグ内に最終的な答えを書いてください。

    ロジック：
    - 道路が冠水しているか、大量の水が溜まっている場合は「ABNORMAL」と答えてください。
    - 道路が冠水していないか、少量の水が溜まっている場合は「NORMAL」と答えてください。

    サンプル出力：
      <thinking>
      ステップ1：画像に写っているものを書き出す。
      - 夜間の道路
      - 道路沿いのフェンス
      - 道路脇の植生
      - 道路上の水
      - 道路上の標識

      <image_caption>
      夜間の道路に水が多く溜まっており、フェンスや植生が映っている。道路上には標識も見える。
      </image_caption>

      ステップ2：道路が冠水しているかを評価する。
      道路に多くの水が溜まっていることから、道路が冠水していると結論できます。
      </thinking>

      <answer>
        ABNORMAL
      </answer>
`

const REDIRECT_LINK = {
    'prod': 'https://wg-wakayama.enepeace.com/login',
    'oiso': 'https://wg-oiso.enepeace.com/login'
}


export {
    ADMIN_SETTING_MENU, FLOOD_GATE_MESSAGES, MANAGER_SETTING_MENU, PAGE_CAMERA_SENSOR_LIST, PAGE_CREATE_SENSOR, PAGE_FLOOD_GATE_SENSOR_LIST, PAGE_FLOOD_SENSOR_LIST, PAGE_GENERAL_SENSOR_LIST, PAGE_LINK, PAGE_MAP,
    PAGE_MASTER_MANAGEMENT, PAGE_MODIFY_SENSOR, PAGE_PROFILE, PAGE_SENSOR_MANAGEMENT,
    PAGE_USER_MANAGEMENT, PAGE_VIEW_SENSOR, ROLE, SENSOR_MANAGE_MENU, SENSOR_PROPERTIES,
    TEXT_SEND_MAIL,
    TEXT_VIEW_MAP, UNDEFINED_TEXT,
    IMAGE_ANALYSIS_USER_PROMPT_DEFAULT,
    IMAGE_ANALYSIS_SYSTEM_PROMPT_DEFAULT,
    REDIRECT_LINK
};